// extracted by mini-css-extract-plugin
module.exports = {"showMoreText":"checkbox-group_showMoreText__wP8KI"};